import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Loader from "../../../../components/atoms/Loader/Loader";
import { useLeadData } from "../../../../hooks/useLeads";
import LeadActions from "./components/LeadActions";
import LeadDetailsContent from "./components/LeadDetailsContent";
import LeadHeader from "./components/LeadHeader";
import LeadModals from "./components/LeadModals";
import { CompanyProfile } from "../../models/ICompanyProfile";

const LeadDetails = () => {
  const { selectedLead } = useLeadData();
  const [isLoading, setLoading] = useState(false);
  const [companyProfile, setCompanyProfile] = useState<CompanyProfile | null>(null);

  useEffect(() => {
    if (!selectedLead?.company) return;
        console.log("Fetching company profile for:", selectedLead.company);
        const fetchCompanyProfile = async () => {
            try {
                setLoading(true);

                const response = await fetch(
                    `${process.env.REACT_APP_API_TODO_LIST_ENDPOINT}/leads/companyProfile/${selectedLead.company}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("AccessToken")}`,
                        }
                    }
                );

                const data = await response.json();

                setCompanyProfile(data);
            } catch (error) {
                console.error("Failed to load company profile", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCompanyProfile();
  }, [selectedLead]);

  const [modals, setModals] = useState({
    location: false,
    social: false,
    confirm: false,
    chat: false,
    IdentityIntelligence: false,
  });

  if (!selectedLead) return <Loader />;

  return (
    <Container fluid className="layout-bar">
      <LeadHeader />

      <div className="details-section">
        <LeadDetailsContent selectedLead={selectedLead} />
        <LeadActions selectedLead={selectedLead} setModals={setModals} />
      </div>

      <LeadModals
        modals={modals}
        setModals={setModals}
        selectedLead={selectedLead}
        companyProfile={companyProfile}
        isLoadingData={isLoading}
      />
    </Container>
  );
};

export default LeadDetails;
